module.exports = __webpack_public_path__ + "img/低通25.836299f6.png";